import React, { useState, useEffect } from "react";
import { Form, Button, Spinner, Modal, Row, Col } from "react-bootstrap";
import iq_api_v2 from "../../services/iqApiV2";
import { useUser } from "../../context/UserContext";
import Alert from "../HtmlElements/Alert";
// import iq_api_v2 from "../api/iq_api_v2"; // adjust path to your API instance
import Select from "react-select";
import api from "../../services/api";
import GenericTableSkeleton from "../Frontend/skeletons/tableSkeleton/genericTableSkeleton";
import { numberWithCommas } from "../../services/commonService";

export default function Signals() {

  const {user} = useUser()
  const [loader, setLoader] = useState(false);
  const [errors, setErrors] = useState({});
  const [addApiError, setApiError] = useState("");
  const [apiSuccess, setApiSuccess] = useState('');
  const [signalList, setSignalsList] = useState([]);
  const [accountList, setAccountList] = useState([]);
  const [saving, setSaving] = useState(false);
  const [showAddSignalModal, setShowAddSignalModal] = useState(false);
  const [customError, setCustomError] = useState({});
  const [searchTerm, setSearchTerm] = useState('');
  const [formData, setFormData] = useState({
    account_name: '',
    account_code: '',
  });

  const [currentRecords, setCurrentRecords] = useState([]); // State for current page records
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage] = useState(10);
  const [sortField, setSortField] = useState('signal_name');
  const [sortOrder, setSortOrder] = useState('asc');
  const [sortedRecords, setSortedRecords] = useState([])
  const [totalPages, setTotalPages] = useState(0);
  const [filteredRecords, setFilteredRecords] = useState([])

  const handleSearch = (e) => {
      // console.log("SEARCH TERM: "+e.target.value);
      setSearchTerm(e.target.value);
  }
  
  useEffect(() => {
      const fetchClientAccounts = async() => {
          let filter = {
            'client_code' : user?.company_id,
            'list_type': 'basic',
          };

          const response = await api.get('/accounts/get_accounts_v2', {
            params: {
              page: 1,
              sort_by: 'account_name',
              order: 'asc', 
              limit: 2000, // perPage
              ...filter,
            },
          });
          let local_db_records = response?.data?.result.list || [];
          if(local_db_records.length){
            let account_list = (local_db_records || []).map(accountInfo => ({
                'account_code': accountInfo.account_code,
                'account_name': accountInfo.account_name,
            }));
            setAccountList(account_list)
          }
      }

      if(user.id){
        fetchClientAccounts();
      }
  }, [user.id])

  // Fetch existing selected seniorities
  useEffect(() => {
    const fetchSignals = async () => {
      try {
        setLoader(true);
        const response = await iq_api_v2.post(
          `/opportunities/get_client_signals`,
          { client: user?.company_name, user_id: user?.id },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        const data = response?.data ?? [];
        setSignalsList(data);
      } catch (error) {
        console.error("Error fetching seniorities:", error);
      } finally {
        setLoader(false);
      }
    };
    fetchSignals();
  }, [user?.id, saving]);

  const handleSort = (field) => {
      const order = sortField === field && sortOrder === 'asc' ? 'desc' : 'asc';
      setCurrentPage(1)
      setSortField(field);
      setSortOrder(order);
  };
  
  const getSortedRecords = () => {
      const sortedRecords = signalList.sort((a, b) => {
          let is_numeric = false;
          // let dataSortField = "financials.0.revenue";
          let dataSortField = "signal_name";

          if (sortField === 'signal_name') {
              dataSortField = "signal_data?.signal?.signal_name";
              is_numeric = false;
          } else if (sortField === 'account') {
              dataSortField = "account";
          } else if (sortField === 'geography') {
              dataSortField = "geography";
          }else if (sortField === 'frequency') {
              dataSortField = "frequency";
          }

          // Helper function to access nested properties by string path
          const getNestedValue = (obj, path) => path.split('.').reduce((acc, part) => acc && acc[part], obj);

          const valueA = getNestedValue(a, dataSortField);
          const valueB = getNestedValue(b, dataSortField);

          // Handling NaN or undefined values
          const numA = is_numeric ? parseFloat(valueA) : valueA;
          const numB = is_numeric ? parseFloat(valueB) : valueB;

          // Handle NaN or undefined by pushing to the bottom
          if (valueA === undefined || valueA === null || valueA === '') return sortOrder === "asc" ? -1 : 1;
          if (valueB === undefined || valueB === null || valueB === '') return sortOrder === "asc" ? 1 : -1;

          // Normal comparison
          if (typeof valueA === 'string' && typeof valueB === 'string') {
          return sortOrder === 'asc' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
          } else {
          if (valueA < valueB) return sortOrder === "asc" ? -1 : 1;
          if (valueA > valueB) return sortOrder === "asc" ? 1 : -1;
          }

          return 0;
      });

      return sortedRecords;
  };

  useEffect(() => {
      if(signalList.length){
        const sortedRecords = getSortedRecords();
        setSortedRecords(sortedRecords);
      }else{
        setSortedRecords([]);
      }

  }, [signalList, sortField, sortOrder]);

  useEffect(() => {
    setCurrentPage(1)
  }, [searchTerm])


  useEffect(() => {
      const lowerSearch = searchTerm.trim().toLowerCase();
      const filteredRecords = sortedRecords.filter((signalInfo) => {
        // Flatten all field values into a single string
        const combinedValues = Object.values(signalInfo)
          .map((val) => {
            if (typeof val === "object" && val !== null) {
              // Handle nested signal object
              return Object.values(val).join(" ");
            }
            return val;
          })
          .join(" ")
          .toLowerCase();

        return combinedValues.includes(lowerSearch);
      });
      const indexOfLastRecord = currentPage * perPage;
      const indexOfFirstRecord = indexOfLastRecord - perPage;
      // const current_records = sortedRecords.slice(indexOfFirstRecord, indexOfLastRecord);
      const current_records = filteredRecords.slice(indexOfFirstRecord, indexOfLastRecord);

      setCurrentRecords(current_records); // Set current page records
      setTotalPages(Math.ceil(filteredRecords.length / perPage));

      setFilteredRecords(filteredRecords)

  }, [currentPage, sortedRecords, sortField, sortOrder, searchTerm]);

  const handleFirstPage = () => {
      setCurrentPage(1);
  };

  const handleLastPage = () => {
      setCurrentPage(totalPages);
  };

  const handlePrevPage = () => {
      if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNextPage = () => {
      if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePageChange = (pageNumber) => {
      setCurrentPage(pageNumber);
  };
  
  const getPageNumbers = () => {
      const pageNumbers = [];
      const startPage = Math.max(1, currentPage - 2);
      const endPage = Math.min(totalPages, currentPage + 2);
      for (let i = startPage; i <= endPage; i++) {
          pageNumbers.push(i);
      }
      return pageNumbers;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevState) => ({
      ...prevState,
      [name]: value !== undefined ? value : '',
    }));

    // Clear the error for the current field
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: '',
    }));

    setCustomError((prevErrors) => {
      const newErrors = { ...prevErrors };
      delete newErrors[name];
      return newErrors;
    });

    // Clear API error
    setApiError('');
  };

  const handleAutoCompleteChange = (selected) => {
      setFormData((prevState) => ({
        ...prevState,
        ['account_name']: selected.account_name !== undefined ? selected.account_name : '',
        ['account_code']: selected.account_code !== undefined ? selected.account_code : '',
      }));

      if(selected.account_code){
        setCustomError((prevErrors) => {
          const newErrors = { ...prevErrors };
          delete newErrors['account_name'];
          return newErrors;
        });
      }
  };

  const handleAddSignal = async (e) => {
    e.preventDefault();

    const newError = {};
    let isValid = true;

    if (!formData?.account_name) {
      newError.account_name = "Account required.";
      isValid = false;
    }

    if (!formData?.signal_name) {
      newError.signal_name = "Signal name required.";
      isValid = false;
    }

    if (!formData?.signal_description) {
      newError.signal_description = "Signal description required.";
      isValid = false;
    }

    if (!formData?.geography) {
      newError.geography = "Signal geography required.";
      isValid = false;
    }

    setCustomError(newError);
    if (!isValid) return;

    const formattedFormData = new URLSearchParams();
    formattedFormData.append("user_id", user?.id);
    formattedFormData.append("client", user?.company_name);
    formattedFormData.append("frequency", 'monthly');
    formattedFormData.append('account', formData.account_name);
    formattedFormData.append('signal_name', formData.signal_name);
    formattedFormData.append('signal_description', formData.signal_description);
    formattedFormData.append('geography', formData.geography);

    setSaving(true);

    try {
      const response = await iq_api_v2.post(
          `/opportunities/add_opportunity_signal`,
          formattedFormData,
          {
            headers: {
              // Accept: "application/json",
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );

        if(response?.data?.message == "success"){
            setApiSuccess("Signal Saved Successfully !");
            handleClose();
        }else{
            setErrors({ save: "Failed to save signal. Please try again." });
        }

        // setTimeout(() => {
        //     setApiSuccess("");
        //     setErrors("")
        // }, 5000);

    } catch (error) {
        console.error("Error saving account signals:", error);
        setErrors({ save: "Failed to save signal. Please try again." });
        setTimeout(() => {
            setApiSuccess("");
            setErrors("")
        }, 5000);

    } finally {
        setSaving(false);
    }
    return false;
  };

  const handleClose = () => {
    setFormData({})
    setShowAddSignalModal(false);
  };

  /*
  const revalidateForm = (e) => {
    const { name, value } = e.target;

    if (formData[name]) {
      setCustomError((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors[name];
        return newErrors;
      });
    }
  };
  */
  
  return (
    
      <div className="row mt-4 nudges_new_wrapper all_acccounts_wrapper ">

        <div className="col-md-12  user_profile_subblock container-fluid">

                {apiSuccess && (
                <Alert type="success" message={apiSuccess} />
                )}
                
                <div className="row mb-2">
                    <div className="col-md-6">
                        <h5 class="target_head mb-0">Signals</h5>
                    </div>

                    <div className="col-md-6 user_form_info d-flex" style={{padding: 0}}>

                        <div className='filter_btn_block mr-2'>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search..."
                                style={{
                                    width: "330px",
                                    height: "32px",
                                    padding: "8px 4px 8px 12px",
                                    border: "0.5px solid #42464847",
                                    backgroundColor: "#FFFFFF",
                                    fontSize: "12.5px",
                                    lineHeight: "15.63px",
                                    fontWeight: "500",
                                    color: "#9595A1"
                                }}
                                value={searchTerm}
                                onChange={(e) => handleSearch(e)}
                            />
                        </div>
                        
                        <div className="d-inline-block float-end">
                          <label
                            className="personalisation_button btn btn-primary btn-sm"
                            onClick={() => {
                              setShowAddSignalModal(true);
                            }}
                          >
                            New Signal
                          </label>
                        </div>
                    </div>
                </div>

                <div className="row">
                {loader ? (
                    <div className="text-center my-3">
                    {/* <Spinner animation="border" size="sm" /> Loading... */}
                    <GenericTableSkeleton colCount={4} rowCount={10} />
                    </div>
                ) : (
                    
                  <>

                    <div className="accounts_table_block ">
                      <div className="table-responsive">
                        <table className="accounts_table ">
                          <thead className="accounts_thead">
                            <tr className="tr_growth">
                              <th
                                className="accounts_th cursorP"
                                width="350"
                              >
                                {/* <FeatherIcon.Box className='icons_table ' /> {' '} */}
                                Name{" "}

                                {sortField === "signal_name" &&
                                (sortOrder === "asc" ? "▲" : "▼")}

                              </th>

                              <th
                                className="accounts_th cursorP" width="100"
                                onClick={() => handleSort("account")}
                              >
                                Account Name{" "}

                                {sortField === "account" &&
                                (sortOrder === "asc" ? "▲" : "▼")}
                              </th>

                              <th
                                className="accounts_th cursorP" width="100"
                                onClick={() => handleSort("geography")}
                              >
                                Geography{" "}

                                {sortField === "geography" &&
                                (sortOrder === "asc" ? "▲" : "▼")}
                              </th>

                              <th
                                className="accounts_th cursorP" width="100"
                              >
                                Frequency{" "}
                              </th>

                              
                            </tr>
                          </thead>

                          <tbody className="accounts_tbody">

                          {currentRecords.map((signal_data, index) => {

                            return (
                                <tr key={`tr_${index}`}>
                                  <td className="accounts_td" style={{
                                    padding: '8px 12px'
                                  }}>
                                    <div className="" style={{
                                      fontWeight: 500
                                    }}> {signal_data?.signal?.signal_name} </div>
                                    <div className="" style={{
                                      color: '#27282d66',
                                      fontWeight: 'normal'
                                    }}>
                                      {signal_data?.signal?.signal_description}
                                    </div>
                                  </td>

                                  <td className="accounts_td" style={{
                                      fontWeight: 'normal',
                                      padding: '8px 12px'
                                    }}>
                                    {signal_data?.account}
                                  </td>

                                  <td className="accounts_td" style={{
                                      fontWeight: 'normal',
                                      padding: '8px 12px'
                                    }}>
                                    {signal_data?.geography}
                                  </td>

                                  <td className="accounts_td" style={{
                                      fontWeight: 'normal',
                                      padding: '8px 12px'
                                    }} >
                                    {signal_data?.frequency
                                    ?.toLowerCase()
                                    ?.replace(/\b\w/g, (char) => char.toUpperCase()) || 'Monthly'}
                                  </td>

                                  
                                </tr>
                              )
                            })}
                          </tbody>
                        </table>
                      </div>

                      <div>
                          <nav className="table_pagination_custom">
                            {signalList.length > perPage && (
                              <ul className="showing-per-page-info">
                                <li className="page-item">
                                  <span className="showing">Showing </span>{" "}
                                  {signalList.length > 0
                                    ? (currentPage - 1) * perPage + 1
                                    : 0}
                                  -{Math.min(currentPage * perPage, filteredRecords.length)} of{" "}
                                  {numberWithCommas(filteredRecords.length)}
                                </li>
                              </ul>
                            )}
              
                            {signalList.length > perPage && (
                              <ul className="pagination">
                                <li
                                  className={`page-item ${
                                    currentPage === 1 ? "disabled" : ""
                                  }`}
                                >
                                  <button onClick={handleFirstPage} className="page-link">
                                    First
                                  </button>
                                </li>
                                <li
                                  className={`page-item ${
                                    currentPage === 1 ? "disabled" : ""
                                  }`}
                                >
                                  <button onClick={handlePrevPage} className="page-link">
                                    <i className="fa fa-angle-left" aria-hidden="true"></i>
                                  </button>
                                </li>
                                {getPageNumbers().map((pageNumber) => (
                                  <li
                                    key={pageNumber}
                                    className={`page-item ${
                                      pageNumber === currentPage ? "active" : ""
                                    }`}
                                  >
                                    <button
                                      onClick={() => handlePageChange(pageNumber)}
                                      className="page-link"
                                    >
                                      {pageNumber}
                                    </button>
                                  </li>
                                ))}
                                <li
                                  className={`page-item ${
                                    currentPage === totalPages ? "disabled" : ""
                                  }`}
                                >
                                  <button onClick={handleNextPage} className="page-link">
                                    <i className="fa fa-angle-right" aria-hidden="true"></i>
                                  </button>
                                </li>
                                <li
                                  className={`page-item ${
                                    currentPage === totalPages ? "disabled" : ""
                                  }`}
                                >
                                  <button onClick={handleLastPage} className="page-link">
                                    Last
                                  </button>
                                </li>
                              </ul>
                            )}
                          </nav>
                        </div>
                    </div>


                    {/* {signalList && signalList.map((signal_data) => {
                        return <div className="offering_custom_card_block">
                            <div className="row">
                                <div className="col-md-6">
                                    <span className="signal_title font13"><b>{signal_data?.signal?.signal_name}</b></span>
                                </div>
                                <div className="col-md-6  align-right">
                                    <span className="signal_title font13"><b>Account:</b> {signal_data?.account}</span>
                                </div>
                                <div className="col-md-12 signal_description  font13">{signal_data?.signal?.signal_description}</div>
                            </div>
                        </div>
                    }) 
                    } */}

                    </>
                )}
                </div>
                
        </div>

        <Modal show={showAddSignalModal} onHide={handleClose} centered>
            <Modal.Header closeButton>
              <Modal.Title>Add Account Signal</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="row">
                {addApiError && (
                  <div className="alert alert-danger">{addApiError}</div>
                )}
              </div>
              <div className="row mb-3">
                <Col md={12} className="mb-3">
                  <label
                    htmlFor="labelCompanyName"
                    className="form-label custom_label"
                  >
                    Account Name <span className="red">*</span>
                  </label>
                  <Select
                    style={{width: '300px'}}
                    className="custom_agentform_control font13"
                    options={accountList} 
                    getOptionLabel={(option) => option.account_name}
                    getOptionValue={(option) => option.account_code}
                    // defaultValue={selectedDemoRequestData?.id}
                    // value={selectedDemoRequestData}
                    onChange={(selected) => handleAutoCompleteChange(selected)}
                    placeholder="Select Account"
                />
                  {customError?.account_name && (
                    <span className="text-danger font13">{customError?.account_name}</span>
                  )}
                </Col>

                <Col md={12} className="mb-3">
                  <Form.Group controlId="sellerAccountName">
                    <Form.Label className="font13">Signal Name <span className="red">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      className="popupInputStyle"
                      name="signal_name"
                      value={formData?.signal_name || ''}
                      onChange={handleChange}
                      // onBlur={revalidateForm}
                      autoComplete="off"
                    />
                    {customError?.signal_name && (
                      <span className="text-danger font13">
                        {customError?.signal_name}
                      </span>
                    )}
                  </Form.Group>
                </Col>

                <Col md={12} className="mb-3">
                  <Form.Group controlId="sellerAccountName">
                    <Form.Label className="font13">Signal Description <span className="red">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      className="popupInputStyle"
                      name="signal_description"
                      value={formData?.signal_description || ''}
                      onChange={handleChange}
                      // onBlur={revalidateForm}
                      autoComplete="off"
                    />
                    {customError?.signal_description && (
                      <span className="text-danger font13">
                        {customError?.signal_description}
                      </span>
                    )}
                  </Form.Group>
                </Col>

                <Col md={12} className="mb-3">
                  <Form.Group controlId="sellerAccountName">
                    <Form.Label className="font13">Geography <span className="red">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      className="popupInputStyle"
                      name="geography"
                      value={formData?.geography || ''}
                      onChange={handleChange}
                      // onBlur={revalidateForm}
                      autoComplete="off"
                    />
                    {customError?.geography && (
                      <span className="text-danger font13">
                        {customError?.geography}
                      </span>
                    )}
                  </Form.Group>
                </Col>

                {/* <Col md={12} className="mb-3">
                  <Form.Group controlId="sellerAccountName">
                    <Form.Label className="font13">Frequency </Form.Label>
                    <Form.Control
                      type="text"
                      className="popupInputStyle"
                      name="frequency"
                      value={formData?.frequency || ''}
                      onChange={handleChange}
                      autoComplete="off"
                    />
                    {customError?.frequency && (
                      <p className="text-danger font13">
                        {customError?.frequency}
                      </p>
                    )}
                  </Form.Group>
                </Col> */}

              </div>
    
            </Modal.Body>
            <Modal.Footer>
              <Button disabled={loader} variant="secondary" onClick={handleClose}>
                Close
              </Button>
              <Button disabled={loader} variant="danger" onClick={handleAddSignal}>
                Submit
              </Button>
            </Modal.Footer>
          </Modal>
    
    </div>
  );
}
